import "./WowMoneyTimer.scss"

import React from "react"

import { useAccount } from "@shared/contexts"

import { useWowMoneyContext } from "live/contexts"

import Accruing from "./Accruing"
import Anonymous from "./Anonymous"
import Completed from "./Completed"
import Notification from "./Notification"

/** 상단바 좌측의 와우머니 적립 현황. 시청자 상태에 따라 셋 중 하나를 보여준다 */
const WowMoneyTimer = () => {
  const {
    account: { viewer },
  } = useAccount()
  const {
    cycleStartedAt,
    cumulativePrice,
    status,
    isFreeSchedule,
    notification,
    clearNotification,
  } = useWowMoneyContext()

  // 유료 편성에서는 Header 가 기존 상단바를 띄운다
  if (!isFreeSchedule) return null

  const renderContent = () => {
    switch (status) {
      case "ANONYMOUS":
        return <Anonymous />
      case "COMPLETED":
        return <Completed username={viewer?.username} />
      case "ENDED":
        // 방송이 끝나 더 적립되지 않으므로 남은 시간은 재지 않는다.
        // cycleStartedAt 을 넘기지 않으면 카운트다운이 멈추고 "-" 로 표기된다
        return <Accruing cumulativePrice={cumulativePrice} />
      case "ACCRUING":
      default:
        return (
          <Accruing
            cumulativePrice={cumulativePrice}
            cycleStartedAt={cycleStartedAt}
          />
        )
    }
  }

  return (
    <div className="userB wowMoneyB">
      {renderContent()}
      {notification && (
        <Notification
          key={notification.id}
          notification={notification}
          onClose={clearNotification}
        />
      )}
    </div>
  )
}

export default WowMoneyTimer
